import { Button as BaseButton } from "antd"
import React from "react"

export function Button(props: React.ComponentProps<typeof BaseButton>) {
    return <BaseButton {...props} />
}
